import { useEffect, useState } from "react";
import { Image, CalendarClock, Globe, Bell } from "lucide-react";
import adminApi from "@/services/adminApi";

const StatCard = ({ icon: Icon, label, value, sub }) => (
  <div className="bg-zinc-900/60 border border-zinc-800 rounded-2xl p-5">
    <div className="flex items-center gap-3 mb-3">
      <div className="w-9 h-9 rounded-lg bg-amber-500/10 flex items-center justify-center">
        <Icon className="w-4.5 h-4.5 text-amber-500" />
      </div>
      <span className="text-sm text-zinc-400">{label}</span>
    </div>
    <p className="text-3xl font-bold">{value}</p>
    {sub && <p className="text-xs text-zinc-500 mt-1">{sub}</p>}
  </div>
);

export default function DashboardPage() {
  const [stats, setStats] = useState({ banners: 0, epgChannels: 0, epgParsed: 0, domains: 0, tokens: 0, pushConfigured: false });

  useEffect(() => {
    Promise.allSettled([adminApi.banners(), adminApi.epgChannels(), adminApi.domains(), adminApi.pushStats()]).then(
      ([b, e, d, p]) => {
        setStats({
          banners: b.status === "fulfilled" ? b.value.data.banners.length : 0,
          epgChannels: e.status === "fulfilled" ? e.value.data.channels.length : 0,
          epgParsed: e.status === "fulfilled" ? e.value.data.channels.filter((c) => c.program_count > 0).length : 0,
          domains: d.status === "fulfilled" ? d.value.data.domains.filter((x) => x.active).length : 0,
          tokens: p.status === "fulfilled" ? p.value.data.total_tokens : 0,
          pushConfigured: p.status === "fulfilled" ? p.value.data.configured : false,
        });
      }
    );
  }, []);

  return (
    <div data-testid="admin-dashboard">
      <h1 className="text-2xl font-bold mb-6">İdarəetmə Paneli</h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <StatCard icon={Image} label="Aktiv Bannerlər" value={stats.banners} />
        <StatCard icon={CalendarClock} label="EPG Kanalları" value={stats.epgChannels} sub={`${stats.epgParsed} kanal parse olunub`} />
        <StatCard icon={Globe} label="Aktiv Domenlər" value={stats.domains} />
        <StatCard icon={Bell} label="Push Tokenlər" value={stats.tokens} sub={stats.pushConfigured ? "Firebase aktiv" : "Firebase konfiqurasiya olunmayıb"} />
      </div>
    </div>
  );
}
